import { initializeApp } from 'firebase/app';
import {
    getAuth, 
    signOut, 
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    sendPasswordResetEmail,
    signInWithRedirect,
    getRedirectResult,
    updateProfile,
    getIdToken,
    deleteUser,
    onAuthStateChanged,
    sendEmailVerification,
    updateEmail,
    sendSignInLinkToEmail,
    isSignInWithEmailLink,
    signInWithEmailLink,
    fetchSignInMethodsForEmail,
} from 'firebase/auth';

let app

export function initFirebaseApp(){
    app = initializeApp(firebaseConfig);
    return app
}

export function getFirebaseApp(){
    return app
}

export function firebaseLogout(){
    const auth = getAuth(app)
    return signOut(auth)
}

export function firebaseUserExist(email) {
    const auth = getAuth(app)

    return signInWithEmailAndPassword(auth, email, " ")
        .catch(error => {
            if (error.code === 'auth/user-not-found') {
                return false
            }
            else if (error.code === 'auth/wrong-password'){
                return true
            }
            else if (error.code === 'auth/invalid-email'){
                throw("invalid-email");
            }
            else if (error.code === 'auth/too-many-requests') {
                throw("too-many-requests");
            }
        })
}

export function firebaseSignInWithEmailAndPassword(email, pass){
    const auth = getAuth(app)
    return signInWithEmailAndPassword(auth, email, pass)
}

export function firebaseCreateUserWithEmailAndPassword(email, pass){
    const auth = getAuth(app)
    return createUserWithEmailAndPassword(auth, email, pass)
}

export function firebaseSigninWithPopup(provider) {
    if (app == null){
        initFirebaseApp()
    }
    const auth = getAuth(app)
    return signInWithPopup(auth, provider)
}

export function firebaseSignInWithRedirect(provider){
    const auth = getAuth(app)
    return signInWithRedirect(auth, provider)
}

export function firebaseGetRedirectResult(){
    const auth = getAuth(app)
    return getRedirectResult(auth)
}

export function firebaseSendPasswordResetEmail(email){
    const auth = getAuth(app)
    return sendPasswordResetEmail(auth, email)
}

export function firebaseGetCurrentUser(){
    const auth = getAuth(app)
    return auth.currentUser
}

export function firebaseUpdateUserName(user, name){
    return updateProfile(user, {displayName: name})
}

export function firebaseGetUserToken(user){
    return getIdToken(user)
}

export function firebaseDeleteUser(user){
    return deleteUser(user)
}

export function firebaseSetLanguageCode(lang){
    const auth = getAuth(app)
    auth.languageCode = lang
}

export function firebaseOnAuthStateChanged(callback){
    const auth = getAuth(app)
    return onAuthStateChanged(auth, callback)
}

export function firebaseSendVerificationEmail(user, actionCodeSettings){
    return sendEmailVerification(user, actionCodeSettings)
}

export function firebaseUpdateEmail(user, email){
    return updateEmail(user, email)
}

export function firebaseSendSignInLinkToEmail(email, actionCodeSettings){
    const auth = getAuth(app)
    return sendSignInLinkToEmail(auth, email, actionCodeSettings)
}

export function firebaseIsSignInWithEmailLink(url){
    const auth = getAuth(app)
    return isSignInWithEmailLink(auth, url)
}

export function firebaseSignInWithEmailLink(email, url){
    const auth = getAuth(app)
    return signInWithEmailLink(auth, email, url)
}

// this method don't work anymore when "email enumeration protection" is enabled
// Instead use php REST API Admin: /accounts:lookup?email=$email
export function firebaseFetchSignInMethodsForEmail(email){
    const auth = getAuth(app)
    return fetchSignInMethodsForEmail(auth, email)
}